export enum LoggerServices {
	PaymentService = 'payment-service',
	NetworkService = 'network-service',
	ChatService = 'chat-service',
	AudioPlayer = 'audio-player',
	UserService = 'user-service',
	BotService = 'bot-service',
	EmailConfirmation = 'email-confirmation',
	ImageLoader = 'image-loader',
	VideoLoader = 'video-loader',
	TestUserService = 'test-user-service',
	AgeConfirmation = 'age-confirmation',
	LocationService = 'location-service',
	RetentionService = 'retention-service',
	Global = 'global',
}

export enum LoggerMessages {
	BuyNeuronsScreenOpened = 'buy-neurons-screen-opened',
	PaymentContextError = 'payment-context-error',
	PaywallContextError = 'paywall-context-error',
	CannotGetPaymentModalRef = 'payment-modal-ref-error',
	CannotCancelSubscription = 'subscription-cancel-error',

	NetworkRequestFailed = 'network-request-failed',
	WebsocketConnectionFailed = 'websocket-connection-failed',
	WebsocketParseFailed = 'websocket-parse-failed',

	AudioPlayerTriedToPlayAudioWithoutToken = 'audio-player-no-token',
	CannotDeleteMessage = 'cannot-delete-message',
	NoBotDataInMessageList = 'no-bot-data-in-message-list',

	ChatReviewContextError = 'chat-review-context-error',
	CannotPlayVideoAvatarInChat = 'chat-video-avatar-error',
	InitiateTopicsError = 'chat-topics-init-error',

	RenderMessageError = 'message-render-error',
	UserDeleteError = 'user-delete-error',
	AuthContextError = 'no-auth-context',
	InvalidBirthday = 'cannot-parse-bday',
	UserInfoUpdateError = 'cannot-update-user-info',

	EmailConfirmationError = 'email-confirmation-error',
	EmailConfirmationSentError = 'email-confirmation-sent-error',

	GenerateImageButtonClicked = 'image-generation-button-clicked',
	GenerateImageSuccessfullySent = 'image-generated-event-successfully-sent',
	ImageGeneratedEventReceived = 'image-generated-event-received',

	GenerateVideoButtonClicked = 'video-generation-button-clicked',
	GenerateVideoSuccessfullySent = 'video-generated-event-successfully-sent',
	VideoGeneratedEventReceived = 'video-generated-event-received',

	BotContextError = 'bot-context-error',

	EmptyMessageInChat = 'empty-message-in-chat',

	ImageLoadingTime = 'image-loading-time',
	ImageLoadingError = 'image-loading-error',
	VideoLoadingTime = 'video-loading-time',
	VideoMessageWithoutMediaId = 'video-message-wo-media-id',

	TestUserMessage = 'test-user-message',

	AgeConfirmationContextError = 'age-context-error',

	LocationRedirectError = 'location-redirect-error',

	NoDataOnRetentionPopup = 'no-user-data-on-retention-popup',

	Unknown = 'unknown-error',
}

export const SERVICE_NAME = 'eden';

export type TLoggerMessages = LoggerMessages | TMotoEvent;

export type TMotoEvent =
	| 'init-start'
	| 'loading-finish'
	| 'card-number-field-click'
	| 'expiration-date-field-click'
	| 'cvv-field-click'
	| 'card-holder-field-click'
	| `charge-term-checkbox${`-${number}`}-check`
	| `charge-term-checkbox${`-${number}`}-uncheck`
	| `user-preference-checkbox${`-${number}`}-check`
	| `user-preference-checkbox${`-${number}`}-uncheck`
	| 'pay-button-click'
	| `${string}-button-click`
	| 'add-card-button-click'
	| 'card-options-button-click'
	| 'remove-card-button-click'
	| 'select-card-button-click';
